// import { createSlice } from '@reduxjs/toolkit';

// const initialState = [];

// const answersSlice = createSlice({
//   name: 'answers',
//   initialState,
//   reducers: {
//     setAnswer(state, action) {
//       const { index, answer } = action.payload;
//       state[index] = { question: state[index].question, answer };
//     },
//     resetAnswers(state) {
//       return initialState;
//     },
//   },
// });

// export const { setAnswer, resetAnswers } = answersSlice.actions;

// export default answersSlice.reducer;
import { createSlice } from '@reduxjs/toolkit';

const answersSlice = createSlice({
    name: 'answers',
    initialState: {
        answers: [],
    },
    reducers: {
        setAnswer: (state, action) => {
            const { index, answer } = action.payload;
            state.answers[index] = answer;
        },
    },
});

export const { setAnswer } = answersSlice.actions;

export default answersSlice.reducer;
